import CollaborationStore from '@/store/collaboration.store';
import SyncSuccessIcon from '@/assets/summary/sync_success.svg?react';
import { isWindows } from '@/utils/platform';
import TranslationSelector from '@/components/TranslationSelector';

const HeaderCollaboration = () => {
  const setShowExitDialog = CollaborationStore((state) => state.setShowExitDialog);
  const showbar = CollaborationStore((state) => state.showSidebar);
  const meetingFinish = CollaborationStore((state) => state.meetingFinish);
  const translationOption = CollaborationStore((state) => state.translationOption);
  const setTranslationOption = CollaborationStore((state) => state.setTranslationOption);

  return (
    <div
      className={`w-full flex flex-row items-center justify-between ${
        isWindows() ? "pl-8" : "pl-25 pr-6"
      }`}
    >
      {meetingFinish && (
        <div className="text-mx-quaternary text-3 lh-6 flex flex-row items-center gap-1">
          <SyncSuccessIcon />
          <span>大屏会议已结束，智能总结生成中...</span>
        </div>
      )}
      <div
        className={`flex-1 h-12 flex justify-end items-center gap-4 ${
          showbar ? "right-92" : "right-50"
        }`}
      >
        <TranslationSelector
          translationOption={translationOption}
          setTranslationOption={setTranslationOption}
        />
        <div className="w-0.25 h-4 bg-#243F6C op-10"></div>
        <div
          onClick={() => {
            setShowExitDialog(true);
          }}
          className="b-1 b-solid b-mx-error flex items-center justify-center rounded-2.5 w-15 h-8 text-mx-error no_drag cursor-pointer"
        >
          退出
        </div>
      </div>
    </div>
  );
};

export default HeaderCollaboration;
